import clsx from 'clsx'
import React, { FC, useContext } from 'react'

import HorizontalSlider from '@Components/Product/Slider/Components/Sliders/Horizontal'
import { SliderContext } from '@Components/Product/Slider/Context/SliderContext'
import SliderController from '@Components/Product/Slider/SliderController'
import SliderOverlay from '@Domains/Product/Features/Display/SliderOverlay/SliderOverlay'
import VerticalSlider from '@Domains/Product/Features/Display/VerticalSlider/VerticalSlider'

import styles from './ProductSliders.module.scss'

const ProductSliders: FC = () => {
  const { isFullscreen } = useContext(SliderContext)

  return (
    <div
      className={clsx(
        styles.wrapper,
        isFullscreen && styles.fullscreen,
        isFullscreen && 'fullscreen',
      )}
    >
      <div className={styles.slider}>
        <SliderController>
          <HorizontalSlider autoHeight className={styles.horizontal} />
          <SliderOverlay />
        </SliderController>
      </div>
      <VerticalSlider />
    </div>
  )
}

export default ProductSliders
